// tslint:disable-next-line: nx-enforce-module-boundaries
import { OwnershipTypeDto, LessorsDto, AddressBookDto } from '@cradua/data';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cradua-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent  {
  @Input() ownershiptypes: OwnershipTypeDto[];
  @Input() quantums: any[];
  @Input() lessors: LessorsDto[];
  @Input() landTitleId: string;
  @Input() addressbooks: AddressBookDto[];
  @Input() LandTitleSerialNo: string;
  @Output() addressssearchevent = new EventEmitter();
  @Output() deletelessorevent = new EventEmitter();
  filteredLessors: LessorsDto[] = [];
  paymentstatus = ['PENDING', 'PAID', 'REJECTED', 'APPROVED'];
  ownerselected: string;
  formcontrol = FormControl
  selectall = false;
  status = '';
  listView = true;
  gridView = false;
  selectaddressbook(book: AddressBookDto) {
    this.selectall = false;
    this.ownerselected = book.id;
    this.filteredLessors = this.lessors.filter(lessor => lessor.Owners === book.id);
  }

  calcAmount() {
   const amount = {
    totalNeg: 0,
    totalAmt: 0,
    }

    if(this.filteredLessors.length > 0) {
      this.filteredLessors.map(a => {
        amount.totalAmt += a.Amount;
        amount.totalNeg += a.NegotiatedAmount;
       });
    }

    return amount;
  }

  searchAddressBook(name) {
    this.addressssearchevent.emit(name);
  }
ngOnChanges(): void {
  this.lessors = this.lessors.filter(lessor =>  lessor.LandTitleSerialNo === this.LandTitleSerialNo);

    this.filterByStatus(this.status);
}

      onList() {
      this.listView = true;
      this.gridView = false;
    }

    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

  filterByStatus(status) {
    this.status = status;
    if(status === 'ALL') {
      this.selectPaymentOption(status)
    } else {
    this.selectall = false;
      this.ownerselected ?
      this.filteredLessors = this.lessors.filter(l => l.PaymentStatus === status &&  l.Owners === this.ownerselected && (l.Payment === 'Acreages' || l.Payment === 'Surface')):
      this.filteredLessors = this.lessors.filter(l => l.PaymentStatus.includes(status) && (l.Payment === 'Acreages' || l.Payment === 'Surface'))
    }

  }

  selectPaymentOption(status) {

    if(status === 'ALL' && this.ownerselected) {
    this.selectall = false;
      this.filteredLessors = this.lessors.filter(l =>( l.PaymentStatus.includes('PAID') || l.PaymentStatus.includes('PENDING') || l.PaymentStatus.includes('REJECTED') || l.PaymentStatus.includes('APPROVED')) &&  (l.Owners === this.ownerselected) && (l.Payment === 'Acreages' || l.Payment === 'Surface'));
    } else {
      this.selectall = true;
      this.filteredLessors = this.lessors.filter(l => l.PaymentStatus.includes('PAID') || l.PaymentStatus.includes('PENDING') || l.PaymentStatus.includes('APPROVED') || l.PaymentStatus.includes('REJECTED') && (l.Payment === 'Acreages' || l.Payment === 'Surface'));
    }
  }

  selectAll() {
    this.ownerselected = null;
    this.selectall = this.selectall ? false : true;
    if(this.selectall) {
      this.selectPaymentOption('ALL')
    } else {
      this.filteredLessors = [];
    }
  }
  deleteLessor(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
      this.deletelessorevent.emit(id);

  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

}

